import {FullPageLoader} from 'organization/theme/FullPageLoader'
import React from 'react'
import {Helmet} from 'react-helmet'

export function LoadingPage() {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,follow" />
      </Helmet>
      <FullPageLoader />
    </>
  )
}
